// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._component-login[data-v-70c98a68] {\n  --component-width: 390px;\n  --content-padding: 15px;\n  --title-text-align: center;\n  width: var(--component-width);\n}\n@media screen and (max-width: 1190px) {\n._component-login[data-v-70c98a68] {\n    --component-width: 100%;\n    --content-padding: 15px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
